import { useState } from 'react';
import { $t } from 'hooks/i18n';
import { Title } from 'components/Title';

import JournalEntryForm from "./JournalEntryForm"
export default function JournalentPage() {
	
	const [pageReady, setPageReady] = useState(true);
	return (
		<main id="JournalentPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <Title title={$t('journalent')}   titleClass="text-lg font-bold text-primary" subTitleClass="text-500"      separator={false} />
                <div className="">
                    <div><JournalEntryForm/></div>
                </div>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
